import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const GlobalStats = lazy(() => import("@root/Statistics/GlobalStats"));
const ErrorPage = lazy(() => import("@root/error"));

export const statisticsRoutes: RouteObject[] = [
  {
    path: "/v2/statistics",
    element: <GlobalStats />,
    errorElement: <ErrorPage />,
  },
];
